module.exports = __webpack_public_path__ + "img/logo-iDEAFP.aaa23686.png";